import * as actions from './holidayMaster/actions'
import * as mutations from './holidayMaster/mutations'
import * as getters from './holidayMaster/getters'

import { dataProps } from './holidayMaster/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/holidayMaster.js